import React from "react";
import { Link } from "gatsby";
import Image from "gatsby-image";
import { getImage } from "~/helpers";
import { Heading, BodyTextAlt } from "~/components/.base/headings";
import { FlexBox, BackgroundDiv } from "~/components/.base/containers";
import no_image from "~/images/collectionList/noimage.jpeg";
import "./ProductGrid.scss";

const ProductGrid = ({ products, bgImages }) => {
  console.log(bgImages);
  return (
    <>
      <BackgroundDiv width="50%" left="0" bottom="0" z="-1">
        <Image fluid={getImage(bgImages, "blurred_smudge_3")} alt="map" />
      </BackgroundDiv>
      <div className="product-grid">
        {products ? (
          products.map(({ title, handle, images, variants }, i) => (
            <Link key={i} to={`/products/${handle}`}>
              <FlexBox
                direction="column"
                justify="space-between"
                align="center"
                className="product-tile"
              >
                <div className="img-cont">
                  {images && images.length ? (
                    <Image
                      fluid={images[0].localFile.childImageSharp.fluid}
                      alt={title}
                    />
                  ) : (
                    <img src={no_image} alt={title} />
                  )}
                </div>
                <div className="details">
                  <BodyTextAlt>{title}</BodyTextAlt>
                  <Heading>
                    <span className="red">{variants[0].price}</span>
                  </Heading>
                </div>
              </FlexBox>
            </Link>
          ))
        ) : (
          <p>No products found!</p>
        )}
      </div>
    </>
  );
};

export default ProductGrid;
